// extracted by css-extract-rspack-plugin
var _1 = "analysis-arrow-lLQqhF";
var _2 = "analysis-arrow-lLQqhF";
export { _1 as "analysis-arrow", _2 as "analysisArrow" }
